module.exports = __webpack_public_path__ + "static/media/21ECLAC51.3b270635.jpg";